import { useContext } from 'react'
import { useState, useEffect } from 'react'
import upperFirst from 'lodash/upperFirst'
import cssVariables from '#src/assets/styles/breakpoints.css'
import { UserAgentContext, UserAgent } from '#src/containers/UserAgent'
import { isMobileNativeOrBrowser } from '#src/services/mobile'
// @ts-ignore
import mediaQuery from 'css-mediaquery'

const getEstimatedDeviceWidth = (ua: UserAgent) => {
  /**
   * HACK: these are very rough estimates for devices sizes. We can drill into the UA
   * and come up with better estimates. e.g. iPhone5 vs iPhone7+
   */
  const isMobileSizedViewport = isMobileNativeOrBrowser(ua)
  if (isMobileSizedViewport) {
    return '350px'
  } else {
    return '1000px'
  }
}

export default function useBreakpoint(breakpointName: string) {
  const ua = useContext(UserAgentContext)

  const estimatedDeviceWidth = getEstimatedDeviceWidth(ua)

  const mediaQueryFeature = cssVariables[`mediaBreakpoint${upperFirst(breakpointName)}`]

  const isMatch = mediaQuery.match(mediaQueryFeature, {
    width: estimatedDeviceWidth
  })

  /**
   * First render should use the value determined by SSR to ensure there are no differences during hydration
   */
  const [matches, setMatches] = useState(isMatch)

  useEffect(() => {
    /**
     * Older (very old) feature phones and browsers may not have matchMedia on the window object
     * https://caniuse.com/#feat=matchmedia
     **/
    if (!window.matchMedia) {
      return
    }

    const mediaQueryList = window.matchMedia(mediaQueryFeature)

    const listener = () => {
      if (mediaQueryList.matches) {
        setMatches(true)
      } else {
        setMatches(false)
      }
    }

    mediaQueryList.addListener(listener)
    setMatches(mediaQueryList.matches)

    return () => mediaQueryList.removeListener(listener)
  }, [breakpointName])

  return matches
}
